// extracted by mini-css-extract-plugin
module.exports = {"Error":"ErrorMessage_Error__3d4cK","IconWrapper":"ErrorMessage_IconWrapper__-ndC2"};